module.exports = __webpack_public_path__ + "static/media/ProductSearch_001.a3cea762.png";